import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Briefcase, FileText, Mail } from "lucide-react";
import { JobPositionsSettings } from "@/components/JobPositionsSettings";
import LandingPageSettings from "@/components/applicants/LandingPageSettings";
import EmailTemplatesSettings from "@/components/applicants/EmailTemplatesSettings";

export const RecruitingSettings = () => {
  const [activeSubTab, setActiveSubTab] = useState("positions");

  return (
    <div className="space-y-6">
      <Tabs value={activeSubTab} onValueChange={setActiveSubTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-3 h-auto gap-1">
          <TabsTrigger value="positions" className="flex items-center gap-2 text-xs sm:text-sm py-2">
            <Briefcase className="h-4 w-4" />
            <span>Stellen</span>
          </TabsTrigger>
          <TabsTrigger value="landingpage" className="flex items-center gap-2 text-xs sm:text-sm py-2">
            <FileText className="h-4 w-4" />
            <span className="hidden sm:inline">Bewerbungsportal</span>
            <span className="sm:hidden">Portal</span>
          </TabsTrigger>
          <TabsTrigger value="emailtemplates" className="flex items-center gap-2 text-xs sm:text-sm py-2">
            <Mail className="h-4 w-4" />
            <span className="hidden sm:inline">E-Mail-Vorlagen</span>
            <span className="sm:hidden">E-Mails</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="positions">
          <JobPositionsSettings />
        </TabsContent>

        <TabsContent value="landingpage">
          <LandingPageSettings />
        </TabsContent>

        <TabsContent value="emailtemplates">
          <EmailTemplatesSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};
